module.exports = __webpack_public_path__ + "static/media/player-join.08c44935.png";